const getHostData =()=>{
    let hostObj = {
        'VUE_APP_APIHOST':'',
        'VUE_APP_SOCKETSERVERHOST':''
    }
    if(process.env.NODE_ENV == 'development'){
        hostObj.VUE_APP_APIHOST = process.env.VUE_APP_APIHOST;
        hostObj.VUE_APP_SOCKETSERVERHOST = process.env.VUE_APP_SOCKETSERVERHOST;
    }else{
        let hostArr = window?.location?.origin.split(window?.location?.protocol);
        hostObj.VUE_APP_APIHOST = window?.location?.origin;
        if(window?.location?.protocol == 'http:'){
            hostObj.VUE_APP_SOCKETSERVERHOST = 'ws:'+hostArr[1]
        }else{
            hostObj.VUE_APP_SOCKETSERVERHOST = 'wss:'+hostArr[1]
        }
    }
    hostObj.VUE_APP_APITIMEOUT = process.env.VUE_APP_APITIMEOUT;
    hostObj.VUE_APP_LOGO = process.env.VUE_APP_LOGO;
    hostObj.VUE_APP_COMPANY = process.env.VUE_APP_COMPANY;
    hostObj.VUE_APP_API_VERSION = process.env.VUE_APP_API_VERSION;
    hostObj.VUE_APP_NAME =  process.env.VUE_APP_NAME;
    hostObj.NODE_ENV = process.env.NODE_ENV;
    return hostObj
}
export {
    getHostData
}
